(() => {
  const copyByLocale = {
    de: {
      text: 'Bei SportsHub verwenden wir notwendige Cookies, damit unser Shop funktioniert. Nur mit deiner Einwilligung setzen wir weitere Cookies ein, um deine Einstellungen zu speichern, die Nutzung unserer Website zu analysieren und Inhalte oder Werbung zu personalisieren. Du kannst diese Cookies akzeptieren, ablehnen oder deine Einstellungen anpassen. Weitere Informationen findest du in unserer',
      link: 'Datenschutzerklärung',
      title: 'Cookie-Einstellungen',
      accept: 'Akzeptieren',
      decline: 'Ablehnen',
      manage: 'Einstellungen anpassen',
    },
    es: {
      text: 'En SportsHub utilizamos cookies necesarias para que la tienda funcione y, solo con tu permiso, otras cookies para recordar tus preferencias, analizar el uso de la web y personalizar contenido o anuncios. Puedes aceptar, rechazar o configurar tus preferencias. Consulta nuestra',
      link: 'Política de privacidad',
    },
    fr: {
      text: 'SportsHub utilise des cookies nécessaires au fonctionnement de la boutique et, uniquement avec votre accord, d’autres cookies pour mémoriser vos préférences, analyser l’utilisation du site et personnaliser les contenus ou publicités. Vous pouvez accepter, refuser ou gérer vos préférences. Consultez notre',
      link: 'Politique de confidentialité',
    },
    it: {
      text: 'Su SportsHub utilizziamo cookie necessari al funzionamento del negozio e, solo con il tuo consenso, altri cookie per ricordare le tue preferenze, analizzare l’utilizzo del sito e personalizzare contenuti o annunci. Puoi accettare, rifiutare o gestire le tue preferenze. Consulta la nostra',
      link: 'Informativa sulla privacy',
      title: 'Consenso all’uso dei cookie',
      accept: 'Accetta',
      decline: 'Rifiuta',
      manage: 'Gestisci preferenze',
    },
    nl: {
      text: 'Bij SportsHub gebruiken we noodzakelijke cookies om de webshop goed te laten werken. Alleen met jouw toestemming gebruiken we andere cookies om je voorkeuren te onthouden, het gebruik van de website te analyseren en inhoud of advertenties te personaliseren. Je kunt cookies accepteren, afwijzen of je voorkeuren beheren. Lees ons',
      link: 'Privacybeleid',
      title: 'Cookietoestemming',
      accept: 'Accepteren',
      decline: 'Afwijzen',
      manage: 'Voorkeuren beheren',
    },
    no: {
      text: 'Hos SportsHub bruker vi nødvendige informasjonskapsler for at nettbutikken skal fungere. Med ditt samtykke bruker vi også andre informasjonskapsler for å huske valgene dine, analysere bruken av nettstedet og tilpasse innhold og annonser. Du kan godta, avslå eller endre valgene dine. Les mer i vår',
      link: 'personvernerklæring',
      title: 'Innstillinger for informasjonskapsler',
      accept: 'Godta',
      decline: 'Avslå',
      manage: 'Tilpass innstillinger',
    },
    pt: {
      text: 'Na SportsHub utilizamos cookies necessários para o funcionamento da loja e, apenas com a tua autorização, outros cookies para recordar as tuas preferências, analisar a utilização do site e personalizar conteúdos ou anúncios. Podes aceitar, recusar ou gerir as tuas preferências. Consulta a nossa',
      link: 'Política de Privacidade',
      title: 'Consentimento para a utilização de cookies',
      accept: 'Aceitar',
      decline: 'Recusar',
      manage: 'Gerir preferências',
    },
  };

  const getPrivacyPolicyUrl = () => {
    const root = window.Shopify?.routes?.root || '/';
    const localizedRoot = root.endsWith('/') ? root : `${root}/`;

    return new URL(
      `${localizedRoot}policies/privacy-policy`,
      window.location.origin
    ).toString();
  };

  const setTextIfNeeded = (element, value) => {
    if (element && value && element.textContent !== value) {
      element.textContent = value;
    }
  };

  const replaceBanner = () => {
    const banner = document.querySelector('#shopify-pc__banner');
    if (!banner) return;

    const locale = (window.Shopify?.locale||document.documentElement.lang).toLowerCase().split('-')[0];
    const copy = copyByLocale[locale === 'nb' ? 'no' : locale] || copyByLocale.es;

    const paragraph = banner.querySelector('.shopify-pc__banner__body p');
    const policyLink = paragraph?.querySelector('#shopify-pc__banner__body-policy-link');

    const privacyPolicyUrl = getPrivacyPolicyUrl();
    if (policyLink && policyLink.href !== privacyPolicyUrl) {
      policyLink.href = privacyPolicyUrl;
    }

    if (paragraph && policyLink && paragraph.dataset.sportshubLocale !== locale) {
      policyLink.textContent = copy.link;
      paragraph.replaceChildren(
        document.createTextNode(`${copy.text} `),
        policyLink,
        document.createTextNode('.')
      );
      paragraph.dataset.sportshubLocale = locale;
    }

    if (copy.title) {
      setTextIfNeeded(banner.querySelector('.shopify-pc__banner__body h2'), copy.title);
      setTextIfNeeded(banner.querySelector('#shopify-pc__banner__btn-accept'), copy.accept);
      setTextIfNeeded(banner.querySelector('#shopify-pc__banner__btn-decline'), copy.decline);
      setTextIfNeeded(banner.querySelector('#shopify-pc__banner__btn-manage-prefs'), copy.manage);
    }
  };

  const handlePrivacyPolicyClick = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const policyLink = target?.closest('#shopify-pc__banner__body-policy-link');
    if (!policyLink) return;

    const privacyPolicyUrl = getPrivacyPolicyUrl();
    if (policyLink.href !== privacyPolicyUrl) {
      event.preventDefault();
      window.location.assign(privacyPolicyUrl);
    }
  };

  const init = () => {
    replaceBanner();

    const observer = new MutationObserver(replaceBanner);
    document.addEventListener('click', handlePrivacyPolicyClick, true);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();